var _a, _b, _c;
export const API_ADDRESS = (_a = process.env.API_ADDRESS) !== null && _a !== void 0 ? _a : '';
export const API_SKIP_AUTH = (_b = process.env.API_SKIP_AUTH) !== null && _b !== void 0 ? _b : false;
export const API_FULL_STYLE_ENDPOINT = (_c = process.env.API_FULL_STYLE_ENDPOINT) !== null && _c !== void 0 ? _c : '';
export const getApiAddress = () => {
    return API_ADDRESS;
};
export const getApiSkipAuth = () => {
    return API_SKIP_AUTH === 'true';
};
export const getApiFullStyleEndpoint = () => {
    return API_FULL_STYLE_ENDPOINT;
};
